import { useState } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import { useAtomValue } from 'jotai'
import { Helmet } from 'react-helmet-async'

import CustomPaper from '@/components/custom-paper'
import MunicipalityLoader from '@/wrappers/municipality-loader'
import { selectedCollectionPointIdAtom, selectedMunicipalityIdAtom } from '@/state'
import CreateContainerRequestForm from '@/components/forms/create-container-request'
import CollectionPointMessageListMunicipality from '@/components/collection-point/message-list-municipality'

function LargeContainerView() {

    const title = 'Objednání kontejneru'

    const collectionPointId = useAtomValue(selectedCollectionPointIdAtom)
    const municipalityId = useAtomValue(selectedMunicipalityIdAtom)

    const [success, setSuccess] = useState<boolean>(false)

    const toggleSuccess = () => {
        setSuccess(!success)
    }

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <CustomPaper>
                <Box sx={{
                    display: 'flex',
                    flexDirection: {
                        xs: 'column',
                        md: 'row',
                    },
                    gap: 3,
                }}>
                    <Box sx={{
                        flexBasis: {
                            xs: '100%',
                            md: '50%',
                            xl: '65%'
                        },
                    }}>
                        <Typography variant="h2" component="h1" mb={2.5}>
                            {title}
                        </Typography>
                        {collectionPointId ?
                            <MunicipalityLoader>
                                {municipality => (
                                    <>
                                        
                                        {success ? 
                                            <Alert
                                                severity="success"
                                                sx={(theme) => ({
                                                    flexGrow: 1,
                                                    margin: theme.spacing(1, 0),
                                                })}
                                                action={
                                                    <Button
                                                        color="success"
                                                        size="small"
                                                        onClick={() => toggleSuccess()}
                                                    >
                                                        Objednat další
                                                    </Button>
                                                }
                                            >
                                                Objednávka velkého kontejneru úspěšně odeslána.
                                            </Alert>
                                            :
                                            <CreateContainerRequestForm
                                                collectionCompanyId={municipality.collection_company.id}
                                                toggleSuccess={toggleSuccess}
                                            />
                                        }
                                    </>
                                )}
                            </MunicipalityLoader>
                            :
                            <Box>
                                Vyberte prosím konkrétní svozové místo výše.
                            </Box>
                        }
                    </Box>
                    <Box sx={(theme) => ({
                        flexBasis: {
                            xs: '100%',
                            md: '50%',
                            xl: '35%'
                        },
                        pl: {
                            xs: 0,
                            lg: 3,
                        },
                        pt: {
                            xs: 3,
                            lg: 0,
                        },
                        borderLeft: {
                            xs: '0px',
                            lg: `1px solid ${theme.palette.customGrey.divider}`,
                        },
                        borderTop: {
                            xs: `1px solid ${theme.palette.customGrey.divider}`,
                            lg: '0px',
                        },
                    })}>
                        <CollectionPointMessageListMunicipality municipalityId={municipalityId} />
                    </Box>
                </Box>
            </CustomPaper>
        </>
    )
}

export default LargeContainerView
